import { useState } from "react";
import { useTranslation } from "react-i18next";
import "./Header.scss";
import logo from "../../assets/LogoGreen.png";

export default function Header() {
	const [open, setOpen] = useState(false);

	const { t, i18n } = useTranslation();
	const currentLang = i18n.language;

	const changeLang = (lang) => {
		i18n.changeLanguage(lang);
		localStorage.setItem("lang", lang);
	};

	return (
		<header className="header">
			<div className="header__container">
				{/* LOGO */}
				<div className="header__logo">
					<img src={logo} alt="Revibrain" />
				</div>

				{/* NAV */}
				<nav
					id="primary-nav"
					className={`header__nav ${open ? "active" : ""}`}
					aria-label="Main navigation">
					<a href="#overview">{t("nav.overview")}</a>
					<a href="#showcase">{t("nav.showcase")}</a>
					<a href="#information">{t("nav.information")}</a>
					<a href="#how">{t("nav.how")}</a>
					<a href="#clinical">{t("nav.clinical")}</a>
					<a href="#footer">{t("nav.footer")}</a>
				</nav>

				{/* LANGUAGE TOGGLE */}
				<div className="header__lang">
					<button
						className={currentLang === "en" ? "active" : ""}
						aria-pressed={currentLang === "en"}
						onClick={() => changeLang("en")}>
						EN
					</button>

					<button
						className={currentLang === "ua" ? "active" : ""}
						aria-pressed={currentLang === "ua"}
						onClick={() => changeLang("ua")}>
						UA
					</button>
				</div>

				{/* BURGER */}
				<button
					type="button"
					className={`header__burger ${open ? "active" : ""}`}
					aria-expanded={open}
					aria-controls="primary-nav"
					aria-label={open ? "Close menu" : "Open menu"}
					onClick={() => setOpen(!open)}>
					<span></span>
					<span></span>
					<span></span>
				</button>
			</div>
		</header>
	);
}
